module.exports = __webpack_public_path__ + "static/media/promo_2.50a24eac.svg";